import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { TabPanels, TabPanel } from '@hub/tabs';
import { NavLinks } from './nav-links';
import { FindACentreNavPanel } from './find-a-centre-panel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UniversalHeaderTabs = ({
  variant,
  centres,
  centre,
  primaryLinks,
  tertiaryLinks,
  openHamburgerMenuAtPath
}) => {
  const navLinksProps = {
    primaryLinks,
    tertiaryLinks,
    openHamburgerMenuAtPath,
    tabKey: 'shop',
    label: 'Shop online'
  };

  switch (variant) {
    case 'gift-cards':
      navLinksProps.tabKey = 'gift-cards';
      navLinksProps.label = 'Gift cards';
      break;

    case 'centre':
      if (centre) {
        navLinksProps.tabKey = 'centre';
        navLinksProps.label = centre && centre.title;
        break;
      }

      break;

    default:
      break;
  }

  const hasShopOnline = ((navLinksProps === null || navLinksProps === void 0 ? void 0 : navLinksProps.primaryLinks) || []).length;
  return /*#__PURE__*/_jsxs(TabPanels, {
    sx: {
      bg: 'smoke',
      borderBottom: '1px',
      borderBottomColor: 'ghost'
    },
    children: [hasShopOnline && /*#__PURE__*/_jsx(TabPanel, {
      tabIndex: -1,
      sx: {
        padding: 0,
        height: 'size-8'
      },
      children: /*#__PURE__*/_jsx(NavLinks, _objectSpread({}, navLinksProps))
    }), variant !== 'centre' && variant !== 'gift-cards' && /*#__PURE__*/_jsx(TabPanel, {
      tabIndex: -1,
      sx: {
        padding: 0,
        height: 'size-8'
      },
      children: /*#__PURE__*/_jsx(FindACentreNavPanel, {
        centres: centres
      })
    })]
  });
};